import { Tabs } from "antd";
import { useForm } from "react-hook-form";
import { CreateModal } from "../../../../shared/components/Modal";
import { DadosPrincipais } from "../../screen/TabsModal/DadosPrincipais";
import { DadosEntregas } from "../../screen/TabsModal/DadosEntregas";
import { ClienteModulo } from "../../types/Clientes";
import { DadosFaturamento } from "../../screen/TabsModal/DadosFaturamento";
import { useGetCliente } from "../../hooks/useGetClientes";
import { useEffect, useState } from "react";
import usePutCliente from "../../hooks/usePutCliente";
import { ProdutoEstoqueCliente } from "../Estoque";
import { ArquivosUpload } from "../Arquivos";
import Swal from 'sweetalert2'

interface ClienteModalProps {
  openModal: () => void
  visible: boolean
  idCliente: number
  deleteModal: () => void
}

export function VisualizarCliente({visible, openModal, idCliente, deleteModal} : ClienteModalProps){
  const { data : clienteData } = useGetCliente(idCliente);  
  const [cliente, setCliente] = useState<ClienteModulo>()
  const [disabled, setDisabled] = useState<boolean>(true)
  const [loading, setIsLoading] = useState<boolean>(false)
  const {mutate : salvarEdicaoCliente} = usePutCliente(resetForm, () => setIsLoading(false));
  const {register, handleSubmit, reset, formState: {errors}} = useForm<ClienteModulo>({
    defaultValues: {
      Nome: cliente?.Nome,
      EmailFinanceiro: cliente?.EmailFinanceiro,
      EmailPrincipal: cliente?.EmailPrincipal,
      EnderecoEntregaCEP: cliente?.EnderecoEntregaCEP,
      EnderecoEntregaCidade: cliente?.EnderecoEntregaCidade,
      EnderecoEntregaEstado: cliente?.EnderecoEntregaEstado,
      EnderecoEntregaLogradouro: cliente?.EnderecoEntregaLogradouro,
      EnderecoEntregaPais: cliente?.EnderecoEntregaPais,
      EnderecoFaturamentoCEP: cliente?.EnderecoFaturamentoCEP,
      EnderecoFaturamentoCidade: cliente?.EnderecoFaturamentoCidade,
      EnderecoFaturamentoEstado: cliente?.EnderecoFaturamentoEstado,
      EnderecoFaturamentoLogradouro: cliente?.EnderecoFaturamentoLogradouro,
      EnderecoFaturamentoPais: cliente?.EnderecoFaturamentoPais,
      Observacoes: cliente?.Observacoes,
      TelefoneCelular: cliente?.TelefoneCelular,
      TelefoneComercial: cliente?.TelefoneComercial,
      TelefoneFax: cliente?.TelefoneFax,
      Website: cliente?.Website,
    }
  });

  function resetForm() {
    reset()
    openModal()
    setIsLoading(false)
    setDisabled(!disabled)
  }

  useEffect(() => {
    clienteData && setCliente(clienteData)
  }, [clienteData])

  async function onSubmit(data : ClienteModulo){
    !navigator.onLine && Swal.fire({
      title: 'Ocorreu um erro',
      text: 'Por favor, verfique sua conexão com a internet e tente novamente.',
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474'
    })

    if(navigator.onLine) {
      await salvarEdicaoCliente({
        clienteAtual: cliente? cliente : clienteData,
        data,
        id : idCliente
      })
      setIsLoading(true)
    }
  }

  function handleHabilitaInput () {
    setDisabled(!disabled)
  }

  return (
    <>
      <CreateModal
        title="Cadastro de Cliente"
        isModalOpen={visible}
        disabled={disabled}
        onCancel={openModal}
        onSubmit={
          handleSubmit(onSubmit)
        }
        deleteOpenModal={() => {
          deleteModal();
        }}
        setDisabled={handleHabilitaInput}
        closable
        hasId
        isLoading={loading}
        >
        <form className="w-[900px] mt-[-1rem]">
          <Tabs
            items = {[
              {
                label: "Dados Principais",
                key: '1',
                children: (
                  <DadosPrincipais 
                    inputDisabled={disabled} 
                    setInputDisabled={setDisabled} 
                    cliente={cliente} 
                    register={register}
                    errors={errors}
                  />
                )
              },
              {
                label: "Dados Entrega",
                key: '2',
                children: (
                  <DadosEntregas
                    inputDisabled={disabled}
                    setInputDisabled={setDisabled}
                    cliente={cliente}
                    register={register}
                    errors={errors}
                  />
                )
              },
              {
                label: "Dados Faturamento",
                key: '3',
                children: (
                  <DadosFaturamento
                    inputDisabled={disabled}
                    setInputDisabled={setDisabled}
                    cliente={cliente}
                    register={register}
                    errors={errors}
                  />
                )
              },
              {
                label: "Estoque",
                key: '4',
                children: (
                  <ProdutoEstoqueCliente clienteId={idCliente}/>
                )
              },
              {
                label: "Arquivos",
                key: '5',
                children: (
                  <ArquivosUpload ClienteId={idCliente}/>
                )
              }
            ]}
          />
        </form>
      </CreateModal>
    </>
  );
}